import React, { useState } from "react";
import Reveal from "@/components/Reveal";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Maximize2 } from "lucide-react";
import { BAND, GALLERY } from "@/data/band";

export default function Gallery() {
  const [open, setOpen] = useState(false);

  return (
    <section id="gallery" data-testid="gallery" className="relative py-24 md:py-32 bg-gradient-to-b from-[#0a0a0b] via-[#0d0d10] to-[#0a0a0b]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
            <div>
              <span className="text-sm font-bold uppercase tracking-[0.25em] text-[var(--sb-red)]">Live</span>
              <h2 className="font-display text-5xl md:text-7xl text-white mt-3">On Stage</h2>
            </div>
            <p className="text-white/55 max-w-sm">
              Moments from the live show. More photos coming as the 2025 run kicks off.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4">
          {GALLERY.map((g, i) => (
            <Reveal key={g.id} delay={i * 0.07} className={g.span}>
              <button
                data-testid={`gallery-${g.id}`}
                onClick={() => setOpen(true)}
                className={`gallery-item group relative w-full h-full rounded-2xl overflow-hidden border border-white/10 hover:border-[var(--sb-red)]/50 transition-colors`}
              >
                <div
                  className="gallery-crop absolute inset-0 bg-cover"
                  style={{ backgroundImage: `url(${BAND.heroImg})`, backgroundPosition: g.pos, backgroundSize: g.size }}
                  aria-hidden
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b]/80 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <span className="text-white font-semibold text-sm uppercase tracking-wider">{g.label}</span>
                </div>
                <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 backdrop-blur-sm rounded-full p-2">
                  <Maximize2 size={16} className="text-white" />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl bg-[#0a0a0b] border-white/15 p-2" data-testid="gallery-lightbox">
          <img src={BAND.heroImg} alt="Songbird live" className="w-full h-auto rounded-lg" />
        </DialogContent>
      </Dialog>
    </section>
  );
}
